export default "__VITE_ASSET__BwBU$hE4__"